import React, { useEffect, useRef, useState } from 'react'
import '../Styles/About.css'
import TrehzLogo from '../Assets/TrehzLogo.png'
import TrehzColourLogo from '../Assets/TrehzColourLogo.png'
import TrehzNameLogo from '../Assets/TrehzNameLogo.png'
import Hartaj from '../Assets/Hartaj.png'
import {getAnalytics, logEvent} from "firebase/analytics";
import { Helmet } from 'react-helmet';
function About() {
  const analytics = getAnalytics();
  const initialized = useRef(false);
  useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            // My actual effect logic...
            logEvent(analytics, 'Visit', { name: 'About Page'})
          }
    },[])
  return (
    <div className="About-container">
      <Helmet>
        <title>The Trehan | About</title>
        <meta name='description' content='The Trehan offers strategic clarity, risk assessments, and data-backed reports on Asia’s shifting landscape—designed for businesses, institutions, and media seeking reliable insights and actionable depth.' data-react-helmet="true"/>
        <meta name="theme-color" content="#000000" data-react-helmet="true"/>
        <meta name='keywords' content='Asia think tank, geopolitical insights, strategic foresight, economic risk analysis, business intelligence Asia, Indo-Pacific reports, war gaming, India market entry, Asia business strategy, political risk workshops' data-react-helmet="true"/>  
        <link rel='canonical' href='/about'/>
      </Helmet>
      <div className="About-landing">
        <img className='About-trehz-logo' src={TrehzLogo} alt='TreHz Logo'></img>
        <h1 className='About-landing-title'>Shaping the new world order</h1>
        <h2 className='About-landing-subtitle'>A TreHz product</h2>
        <p className='About-landing-text'>The Trehan, by TreHz, is a geopolitical and geoeconomic think tank dedicated to enhancing situational awareness and promoting growth through mutual understanding and respect. Enabling organisations to navigate complex global dynamics, assess risks, unlock growth opportunities and advise on the geopolitical realities on ground.</p>
      </div>
      <div className="About-vision">
        <h2 className='About-vision-title'>Vision</h2>
        <p className='About-vision-text'>“To become the leading voice of Asia, bridging global perception gaps and offering strategic clarity in a world shaped by competing powers - accelerating the ascent of India and its region to global prominence through actionable intelligence, data-backed roadmaps, risk assessments, and credible narrative-setting. Trusted by leaders, institutions, and enterprises seeking depth, neutrality, and foresight.”</p>
      </div>
      <div className="About-mission">
        <h2 className='About-mission-title'>Mission</h2>
        <p className='About-mission-text'>The Trehan is dedicated to become the biggest strategic resource for organisations, start ups, investors and governments by:</p>
        <ul className='About-missions'>
          <li className='About-mission-item'>Publishing independent, data-driven intelligence that highlights untapped markets and unseen risks. </li>
          <li className='About-mission-item'>Deliver data-driven reports to businesses identifying untapped opportunities and critical infrastructural gaps in India.</li>
          <li className='About-mission-item'>Guiding businesses and governments through complex environments with clear roadmaps and actionable insights.</li>
          <li className='About-mission-item'>Offer geopolitical foresight, risk intelligence, and deep research that is indispensable for international firms with interests in Asia.</li>
          <li className='About-mission-item'>Creating thought leadership that competes with legacy narratives and adds balance to global discourse.</li>
          <li className='About-mission-item'>Serving as a bridge between rising economies and international stakeholders.</li>
          <li className='About-mission-item'>Remaining financially independent to ensure bold, uncompromised analysis with real-world impact.</li>
        </ul>
      </div>
      <div className="About-team">
        <div className='About-team-member'>
          <img className='About-team-member-photo' src={Hartaj} alt='Hartaj'></img>
          <p className='About-team-member-name'>Hartaj Singh Trehan</p>
          <p className='About-team-member-position'>CEO & Editor-in-Chief</p>
          <p className='About-team-member-about'>Aerospace Engineer, Entrepreneur, Geo-Political Analyst, Full-Stack Developer, Artist</p>
        </div>
      </div>
    </div>
    
  )
}

export default About